<template>
<div>
  <vs-card class="cstm_vx_card">
    <vs-row vs-justify="space-between" slot="header">
      <h4>Award</h4>
      <vs-button
       v-if="checkEditPermission()"
        type="border"
        color="primary"
        style="font-size: 13.8px; padding: 7px; float: right;"
        @click="addpopup = true"
      >
        Add
      </vs-button>
    </vs-row>

      <div class="vx-row">
        <!-- {{ awardAvailability }} -->
        <vs-table :data="awardProps" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="year">Date</vs-th>
            <vs-th sort-key="name">Award Name</vs-th>
            <vs-th sort-key="date">Award Description</vs-th>
            <vs-th sort-key="status" style="width: 250px;">Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(item, indextr) in data">
              <vs-td :data="data[indextr].year">
                {{ data[indextr].year }}
              </vs-td>
              <vs-td :data="data[indextr].award_name">
                {{ data[indextr].award_name }}
              </vs-td>

              <vs-td :data="data[indextr].award_description">
                {{ data[indextr].award_description }}
              </vs-td>
              <vs-td :data="data[indextr]">
                <vs-row vs-type="flex">
                   <vs-button v-if="data[indextr].picture"
                  icon-pack="feather"
                  class="mr-2"
                    type="filled"
                    @click="preview(data[indextr].picture)"
                    icon="icon-eye"
                    color="primary"
                  />
                  <vs-button color="primary" v-if="checkEditPermission()" type="filled" icon="edit" class="mr-2" @click="handleedit(indextr)"/>
                  <vs-button type="filled" v-if="checkDeletePermission()" @click="remove(indextr)" icon="delete" color="danger"/>
                </vs-row>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>


    <vs-popup classContent="popup-example"  title="Delete" :active.sync="deletepopup">
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <vs-popup classContent="popup-example"  title="Add Award" :active.sync="addpopup">
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <!-- <span style="font-size:11px;">Year</span> -->
            <vs-input v-model="award.year" v-validate="'required|min:4|max:4|numeric'" name="year" class="custom_Input" label="Year" icon-pack="feather" icon="icon-edit" icon-after  style="width:100%;" />
            <span v-show="errors.has('add.year')" class="text-danger">{{ errors.first('add.year') }}</span>
            <!-- <datepicker v-model="award.year" placeholder="Date" style="width:100%;" /> -->
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="award-name" v-model="award.award_name" class="custom_Input" label="Award Name" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
              <span v-show="errors.has('add.award-name')" class="text-danger">{{ errors.first('add.award-name') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-textarea class="mb-0" name="award-description"  v-model="award.award_description" label="Award Description" style="width:100%;"/>
         
          </vs-col>
          <!-- <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-textarea v-model="award.award_description" label="Award Description" style="width:100%;"/>
          </vs-col> -->
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2 centerx">
            <!-- {{ imageDataUrl }} -->
            <div class="w-full">{{previewImageName}}</div>
            <label class="block mb-4" for="myfile">Upload Certificate:</label>
            <FileUpload :platform_module_id="2" @changingImage="saveImage"></FileUpload>
            <!-- <input type="file" id="myfile" name="myfile" @change="uploadImg($event, 1, add)"> -->
            <!-- <vs-button color="primary" @click="saveImage">Upload</vs-button> -->
            <!-- <vs-upload automatic action="http://scoolio-backend.track-progress.com/api/file/image" fileName="field_name" :show-upload-button="true" :single-upload="true" @on-success="successUpload" /> -->
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="addpopup  = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>


    <vs-popup classContent="popup-example"  title="Edit Award" :active.sync="editpopup">
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <!-- <span style="font-size:11px;">Year</span> -->
            <vs-input v-validate="'required|min:4|max:4|numeric'" name="year" v-model="edit.year"  class="custom_Input" label="Year" icon-pack="feather" icon="icon-edit" icon-after style="width:100%;" />
            <span v-show="errors.has('edit.year')" class="text-danger">{{ errors.first('edit.year') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="award-name" v-model="edit.award_name" class="custom_Input" label="Award Name" icon-pack="feather" icon="icon-edit" icon-after  style="width:100%;"  />
              <span v-show="errors.has('edit.award-name')" class="text-danger">{{ errors.first('edit.award-name') }}</span>
          </vs-col>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-textarea name="award-description" v-model="edit.award_description" label="Award Description" style="width:100%;"/>
          </vs-col>
          <!-- <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-textarea v-model="award.award_description" label="Award Description" style="width:100%;"/>
          </vs-col> -->
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2 centerx flex-wrap" vs-type="flex" vs-justify="space-between">
            <!-- {{ imageDataUrl }} -->
            <!-- <div class="w-full" v-if="previewImageName == ''">{{edit.picture}}</div>
            <div class="w-full" v-else>{{previewImageName}}</div> -->
            <div class="w-full"><label for="myfile">Uploaded Certificate:</label>
             <FileUpload :platform_module_id="2" @changingImage="saveImageedit" :image="edit.picture" ></FileUpload>
            <!-- <input type="file" id="myfile" name="myfile" @change="uploadImg($event, 1, edit)"> -->
            </div>
            <!-- <vs-button color="primary" @click="saveImageedit">Upload</vs-button> -->
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdateAvailiblity">Save</vs-button>
        <vs-button type="border" color="danger" @click="editpopup = false">Cancel</vs-button>
      </vs-row>
    </vs-popup>
          <vs-popup
      classContent="popup-example"
      title="Preview"
      :active.sync="previewPopup"
    >
     
       <vs-row>
            <img :src="file_url">
        </vs-row>
    </vs-popup>
</div>
</template>
<script>
import FileUpload from '@/views/pages/v1/user_profile/components/profile/personal_information/certificateFile.vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker'
import { UploadImage } from '@/api/common'
import {  TeacherUpdate } from '@/api/teacher'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  name: 'email',
  components: {
    flatPickr,
    vSelect,
    Datepicker,
    FileUpload
  },
    created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  props: {
    awardProps: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  watch:{
    awardProps:{
      deep:true,
      immediate:true,
      handler () {
        this.awardAvailability = this._.cloneDeep(this.awardProps)
      }
    }
  },
  data () {
    return {
      file_url:'',
      previewPopup:false,
      previewImageName: '',
      awardAvailability:[],
      addpopup: false,
      deletepopup:false,
      editpopup: false,
      days:[
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      award: {
        award_description:null,
        award_name: null,
        picture: null,
        year: null
      },
      edit: {
        award_description:null,
        award_name: null,
        picture: null,
        year: null
      },
      editIndex: null,
      deleteindex: false,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      imageDataUrl: null,
      fileName: ''
    }
  },
  /*  computed: {
    awardAvailability: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }, */
  methods: {
    preview(data){
      this.previewPopup= true;
      this.file_url = data
    }, 
        saveImage(url){
      this.award.picture = url
    },
    saveImageedit(url){
      this.edit.picture = url
    },
    handlePhonedefault (index) {
      this.awardAvailability.map(item => {
        item.default = 0
      })
      this.awardAvailability[index].default = 1
    },
    handleSave () {
      this.$validator.validateAll('add').then(result => {
        if (result) {
          const payload = this.award
          this.awardAvailability.push(payload)
          this.handleAwardsave()
        }
      })

    },
    handleedit (index) {
      // 
      this.editpopup = true
      
      this.edit = this.awardAvailability[index]
      this.editIndex =  index
    },
    handleUpdateAvailiblity () {
      this.$validator.validateAll('edit').then(result => {
        if (result) {
          this.awardAvailability[this.editIndex] = this.edit
        }
        this.handleAwardsave()

      })

    },
    handleDelete () {
      this.awardAvailability.splice(this.deleteindex, 1)
      this.handleAwardsave()

    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    uploadImg (e, num, type) {
      const file = e.target.files[0]
      const fileSize = ((e.target.files[0].size / 1024) / 1024)
      const FileType = file.type
      this.fileName = FileType.replace('/', '.')
      if (fileSize < 5) {
        // this.dialogVisible = true
        // 
        if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG|PDF)$/.test(e.target.value)) {
          alert('File Should be must this (.gif,jpeg,jpg,png,bmp,pdf) type')
          return false
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          const formData = new FormData()
          formData.append('myFile', file)
          let data = null
          if (typeof e.target.result === 'object') {
            data = new Blob([e.target.result])
            // fd.append('upload_path', 'FeedWall')
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.imageDataUrl = data
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        reader.readAsArrayBuffer(file)
        // 
      } else {
        this.option.img = ''
        
        this.dialogVisible = false
        this.$vs.notify({
          title:'warning',
          text: 'Image sie is too large',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color:'warning'
        })
        return false
      }
      if (type === 'edit') {
        this.previewImageName = file.name
      } 
    },
    // async saveImageedit () {
    //   try {
    //     // const payload = {
    //     //   image: this.imageDataUrl
    //     // }
    //     const fd = new FormData()
    //     fd.append('files[]', this.imageDataUrl, this.fileName)
    //     // fd.append('upload_path', 'FeedWall')
    //     const customer_id = this.$store.state.LoginStorage.user_details.customer_id
    //     const { data } = await UploadImage(fd, customer_id)
    //     this.edit.picture = data.data.files[0].file_path
    //     // 
    //     this.$vs.notify({
    //       title:'Success',
    //       text: 'file uploaded Successfully',
    //       icon: 'feather',
    //       iconPack: 'icon-alert-circle',
    //       color:'success'
    //     })
    //   } catch (e) {
    //     this.$vs.notify({
    //       title:'error',
    //       text: e,
    //       icon: 'feather',
    //       iconPack: 'icon-alert-circle',
    //       color:'error'
    //     })
    //   }
    // },
    // async saveImage () {
    //   try {
    //     // const payload = {
    //     //   image: this.imageDataUrl
    //     // }
    //     const fd = new FormData()
    //     fd.append('files[]', this.imageDataUrl, this.fileName)
    //     // fd.append('upload_path', 'FeedWall')
    //     const customer_id = this.$store.state.LoginStorage.user_details.customer_id
    //     const { data } = await UploadImage(fd, customer_id)
    //     this.award.picture = data.data.files[0].file_path
    //     // 
    //     this.$vs.notify({
    //       title:'Success',
    //       text: 'file uploaded Successfully',
    //       icon: 'feather',
    //       iconPack: 'icon-alert-circle',
    //       color:'success'
    //     })
    //   } catch (e) {
    //     this.$vs.notify({
    //       title:'error',
    //       text: e,
    //       icon: 'feather',
    //       iconPack: 'icon-alert-circle',
    //       color:'error'
    //     })
    //   }
    // },
    async handleAwardsave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            awards: this.awardAvailability
          }
        }
        const {data} = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )
        // this.setAfterUpdate(data)

        this.addpopup = false
        this.award = {
          award_description:null,
          award_name: null,
          picture: null,
          year: null
        }
        this.editpopup  = false

        this.deletepopup = false

        this.$emit('setAfterUpdate', data)
        // this.fetchTeacherDetails(this.$route.params.teacher_id)
        // this.bioEditPopup = false
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')

      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>
